import React, { useContext, useMemo, useState } from "react";
import { NoImage } from "../Images";
import { MdLocationPin } from "react-icons/md";
import { BsFillEnvelopeCheckFill } from "react-icons/bs";
import { FaPhoneVolume } from "react-icons/fa";
import { Link } from "react-router-dom";
import CommonContext from "../Context/context";

import { htmlRegexG } from "../Helper/helperFunctions";
import { toast } from "react-toastify";
import { postContact } from "../Service/ApiFunction";
const emptyData = {
  fullName: "",
  email: "",
  subject: "",
  message: "",
  phoneNumber: "",
  file: "demo",
};
const Contact = () => {
  const { GlobalData, ContactNumber, cmsData } = useContext(CommonContext);

  const [contactData, setContactData] = useState(emptyData);
  const [loader, setLoader] = useState(false);
  const address = useMemo(
    () => GlobalData?.find((ele) => ele?.title == "address")?.file,
    [GlobalData]
  );
  const email = useMemo(
    () => GlobalData?.find((ele) => ele?.title == "send_Message")?.file,
    [GlobalData]
  );
  const ContactPage = useMemo(
    () => cmsData?.find((ele) => ele?.page == "Contact Us"),
    [cmsData]
  );
  const ContactPageImage = useMemo(
    () => GlobalData?.find((ele) => ele?.title == "contact_Us_Image")?.file,
    [GlobalData]
  );
  const createFormdata = (name, value) => {
    setContactData((old) => {
      return {
        ...old,
        [name]: value,
      };
    });
  };

  const postContactData = async () => {
    setLoader(true);
    if (
      contactData?.fullName == "" ||
      contactData?.phoneNumber == "" ||
      contactData?.email == "" ||
      contactData.message == "" ||
      contactData.subject == ""
    ) {
      setLoader(false);
      toast.error("Please Fill All The Fields");
      return;
    }
    try {
      const responseContact = await postContact(contactData);
      if (responseContact?.ack == 1) {
        toast.success("Successfully Contacted..");
        setLoader(false);
        setContactData(emptyData);
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };
  return (
    <>
      <section className="page-title">
        <div className="container">
          <div className="content-box">
            <div className="content-wrapper">
              <div className="title">
                <h1>Contact Us</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-section">
        <div className="container">
          <div className="row">
            <div className="top-content mb-4 d-flex justify-content-center align-items-center text-center">
              <div className="sec-title">
                <h2>
                  Bharatpur St. Mary (H.S) <br /> - Get In Touch
                </h2>
              </div>
            </div>
          </div>
          <div className="tab-area mt-4">
            <div className="row">
              <div className="col-lg-4 contact-info-block">
                <div className="inner-box">
                  <div className="icon">
                    <MdLocationPin />
                  </div>
                  <h4>School Address</h4>
                  <div className="text">
                    {address || "Kolkata,West Bengal, INDIA"}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 contact-info-block">
                <div className="inner-box">
                  <div className="icon">
                    <FaPhoneVolume />
                  </div>
                  <h4>Phone Us</h4>
                  <ul>
                    <li>
                      Mob: <Link>{ContactNumber?.file || "0000000000"}</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 contact-info-block">
                <div className="inner-box">
                  <div className="icon">
                    <BsFillEnvelopeCheckFill />
                  </div>
                  <h4>Send Email</h4>
                  <ul>
                    <li>
                      <Link>{email || "demo.co@gmail.com"}</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-form-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="image">
                <img src={ContactPageImage || NoImage} alt="" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="sec-title mb-30">
                <div className="sub-title">
                  {ContactPage?.description
                    ? ContactPage?.description?.replace(htmlRegexG, "")
                    : "Our Contact Page Is Always At Your Service '"}
                </div>
                <h2 className="mb-4">
                  Any Questions? Fill-In <br /> The Form & Send Today!
                </h2>
              </div>
              <div className="contact-form">
                <form>
                  <div className="row">
                    <div className="form-group col-md-12">
                      <input
                        value={contactData?.fullName}
                        type="text"
                        name="fullName"
                        placeholder="Your Full Name"
                        onChange={(e) =>
                          createFormdata(e.target.name, e.target.value)
                        }
                        required
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <input
                        type="email"
                        onChange={(e) =>
                          createFormdata(e.target.name, e.target.value)
                        }
                        name="email"
                        value={contactData?.email}
                        placeholder="Your Email"
                        required
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <input
                        type="number"
                        name="phoneNumber"
                        placeholder="Your Phone Number"
                        onChange={(e) =>
                          createFormdata(e.target.name, e.target.value)
                        }
                        value={contactData?.phoneNumber}
                        required
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <input
                        type="text"
                        name="subject"
                        value={contactData?.subject}
                        placeholder="Subject"
                        onChange={(e) =>
                          createFormdata(e.target.name, e.target.value)
                        }
                        required
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <textarea
                        name="message"
                        placeholder="Massage"
                        value={contactData?.message}
                        onChange={(e) =>
                          createFormdata(e.target.name, e.target.value)
                        }
                      ></textarea>
                    </div>
                    <div className="form-group col-md-12">
                      <button
                        disabled={loader}
                        className="theme-btn btn-style-one"
                        type="submit"
                        onClick={(e) => {
                          postContactData(e);
                        }}
                      >
                        {loader ? (
                          <div class="spinner-border text-dark" role="status">
                            <span class="sr-only"></span>
                          </div>
                        ) : (
                          <>
                            <span>Send Message</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
